import { sectionNavigationTopOffset } from './utils';

export const observeStickyNavigationOffset = (navigation: HTMLElement) => {
  const headers = [
    document.querySelector<HTMLElement>('[data-testid="section-container"]'),
    document.getElementById('SITE_HEADER'),
  ];
  const candidates = new Set<HTMLElement>();
  headers.forEach((header) => {
    for (let element = header; element && element !== document.body; element = element.parentElement) {
      candidates.add(element);
    }
  });

  const updateOffset = () => {
    const adsHeight = parseFloat(window.getComputedStyle(navigation).getPropertyValue('--wix-ads-height')) || 0;
    let offset = 0;
    candidates.forEach((element) => {
      const style = window.getComputedStyle(element);
      const top = parseFloat(style.top);
      if ((style.position === 'sticky' || style.position === 'fixed') && Number.isFinite(top)) {
        // The navigation CSS already includes the Wix banner height.
        offset = Math.max(offset, top + element.getBoundingClientRect().height - adsHeight);
      }
    });
    navigation.style.setProperty(sectionNavigationTopOffset, `${offset}px`);
  };

  updateOffset();
  const observer = window.ResizeObserver ? new window.ResizeObserver(updateOffset) : undefined;
  const positioningObserver = new window.MutationObserver(updateOffset);
  candidates.forEach((element) => {
    observer?.observe(element);
    positioningObserver.observe(element, { attributes: true, attributeFilter: ['style', 'class'] });
  });
  window.addEventListener('resize', updateOffset);

  return () => {
    observer?.disconnect();
    positioningObserver.disconnect();
    window.removeEventListener('resize', updateOffset);
    navigation.style.removeProperty(sectionNavigationTopOffset);
  };
};
